import React from 'react';

import {Image} from 'src/components/shared/Image';
import styled from 'styled-components/macro';

import {SanityLabelledImage} from 'types/generated';

const Container = styled(Image).attrs({
  margin: 0,
  padding: 0,
  width: '100%',
  height: '100%',
})`
  object-fit: cover;
`;

export const QuoteImage: React.FC<SanityLabelledImage> = props => {
  return (
    <div>
      <Container src={props.asset?.url || ''} alt={props.altText || ''} />
    </div>
  );
};
